module.exports = __webpack_public_path__ + "img/park-live-first-logo.a474aed0.svg";